import '../styles/SolutionsComponent.css';
import '../styles/ContactComponent.css';
//import EmailFormComponent from './EmailFormComponent.jsx';

const ContactComponent = ({ contactContent, emailLabels }) => {
    if (!contactContent || !contactContent.contact) {
        return null;
    }

    const { title, subtitle, description, contact } = contactContent;

    const renderContactItem = (item, index) => (
        <div className="col" style={{ textAlign: 'center' }} key={index}>
            <div className="row" style={{ display: 'flex', justifyContent: 'center' }}>
                <img
                    id="icon"
                    src={item.icon}
                    alt={item.heading}
                    className="img-fluid mb-2"
                    style={{ maxWidth: '50px' }}
                />
            </div>
            <div className="row" style={{ alignText: 'center' }}>
                <h3
                    className="title mb-1"
                    id="contact-heading"
                    style={{
                        fontSize: 20,
                        color: '#ffffffff',
                        textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
                        fontWeight: 'bold'
                    }}
                >
                    {item.heading}
                </h3>
            </div>
            <div className="row" style={{ alignText: 'center' }}>
                <p
                    className="text"
                    id="contact-text"
                    style={{
                        fontSize: 14,
                        color: '#ffffffff',
                        textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
                        whiteSpace: 'pre-line',
                        margin: 0
                    }}
                >
                    {item.description}
                </p>
            </div>
        </div>
    );

    return (
        <div className="container">
            <div className="row" id="solutions">
                <div className="col-12">
                    <div className="row">
                        <div className="col-md-6 text-left text-md-start mb-4 mb-md-0">
                            <h2
                                className="my-3 title"
                                id="contact-title"
                                style={{
                                    color: '#ffffffff',
                                    textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
                                    fontWeight: '900'
                                }}
                            >
                                {title}
                            </h2>
                            <h3
                                className="my-2 title"
                                id="contact-subtitle"
                                style={{
                                    color: '#ffffffff',
                                    textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
                                    fontWeight: '700',
                                    fontSize: 20
                                }}
                            >
                                {subtitle}
                            </h3>
                            <p
                                className="text"
                                id="contact-desc"
                                style={{
                                    color: '#ffffffff',
                                    textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
                                    fontWeight: '400',
                                    fontSize: 16
                                }}
                            >
                                {description}
                            </p>
                            {/** <EmailFormComponent emailLabels={emailLabels} />*/}
                        </div>

                        <div className="col-md-6 d-flex justify-content-center map">
                            <iframe
                                title="Google Map"
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2848.204630236988!2d26.1477542763973!3d44.44947507107557!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40b1f927a6dd00cf%3A0x816641f69c0ad485!2sStrada%20Vulcanei%202%2C%20Bucure%C8%99ti!5e0!3m2!1sen!2sro!4v1760001337196!5m2!1sen!2sro"
                                width="100%"
                                height="300"
                                style={{ border: 0, borderRadius: '10px' }}
                                allowFullScreen
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                            ></iframe>
                        </div>
                    </div>
                </div>

                <div className="col-12 mt-4">
                    <div className="row justify-content-center">
                        {contact.map((item, idx) => renderContactItem(item, idx))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactComponent;
